import { FETCH_USER_SUCCESS } from './actionTypes';

export const fetchUserSuccess = user => ({ type: FETCH_USER_SUCCESS, payload: user });
